export const convertDateToISO = (dateString: string): string => {
  // Converte DD/MM/AAAA para YYYY-MM-DD
  const [day, month, year] = dateString.split("/");
  return `${year}-${month}-${day}`;
};

export const convertDateToTimestamp = (
  dateString: string,
  timeString: string
): number => {
  // Converte YYYY-MM-DD e HH:MM para timestamp
  const [year, month, day] = dateString.split("-");
  const [hour, minute] = timeString.split(":");

  const date = new Date(
    parseInt(year),
    parseInt(month) - 1, // Mês começa em 0
    parseInt(day),
    parseInt(hour),
    parseInt(minute)
  );

  return date.getTime();
};
